import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { SectionNumber } from '@components/Section-Number';
import { Separator } from '@components/Separator';
import { SectionAnchor } from '@components/Section-Anchor';
import { ImageSet } from './organism/image-set';

export const NeuralNetwork = () => {
  const translations = useTranslations();

  return (
    <View id="neural-network">
      <Container>
        <Content>
          <ColumnInfo>
            <SectionNumber number={''} text={translations.t('site.home.neural-network.name')} />
            <Title>{translations.t('site.home.neural-network.title').replace(/\\n/g, '\n')}</Title>
            <Description>{translations.t('site.home.neural-network.description')}</Description>

            <ImagesMobile>
              <ImageSet />
            </ImagesMobile>

            <Separator />
            <Text dangerouslySetInnerHTML={{ __html: translations.t('site.home.neural-network.text') }}></Text>
            <SectionAnchor text={translations.t('site.home.neural-network.anchor')} />
          </ColumnInfo>

          <ColumnPlan>
            <ImageSet />
          </ColumnPlan>
        </Content>
      </Container>
    </View>
  );
};

const View = styled.section`
  height: auto;
  position: relative;
  overflow: hidden;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: ${Colors.white};

  @media ${Points.tablet_landscape} {
    padding-bottom: 52px;
  }

  @media ${Points.laptop_wide} {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  @media ${Points.fullhd} {
    padding-bottom: 130px;
  }
`;
const Container = styled.div`
  width: 100%;
`;
const Content = styled.div`
  flex-direction: row-reverse;
  width: 100%;
  margin: 0 auto;
  padding: 0 16px;

  @media ${Points.tablet_landscape} {
    display: flex;
    align-items: flex-start;
    width: 100%;
    max-width: 1024px;
    padding: 0 28px;
  }

  @media ${Points.laptop_wide} {
    width: 100%;
    max-width: 1600px;
    padding: 0 80px;
  }

  @media ${Points.fullhd} {
    padding: 0;
  }
`;

const ColumnInfo = styled.div`
  width: 100%;

  @media ${Points.tablet_landscape} {
    margin-left: 38px;
    margin-top: 10px;
    min-width: 380px;
    max-width: 800px;
  }

  @media ${Points.laptop_wide} {
    margin-top: 10px;
    margin-left: 62px;
  }
  @media ${Points.fullhd} {
    margin-left: 82px;
    margin-top: 20px;
  }
`;
const ImagesMobile = styled.div`
  margin-top: 15px;

  @media ${Points.tablet_landscape} {
    display: none;
  }
`;
const ColumnPlan = styled.div`
  display: none;
  margin-right: -16px;
  margin-left: -16px;
  flex-grow: 1;

  @media ${Points.tablet_landscape} {
    margin-right: 0;
    margin-left: 0;
    display: block;
  }
`;
const Title = styled.div`
  font-size: 26px;
  line-height: 1;
  color: ${Colors.main_dark};
  margin-bottom: 15px;
  font-weight: 400;
  white-space: pre-line;

  @media ${Points.tablet_portrait} {
    text-align: center;
  }

  @media ${Points.tablet_landscape} {
    text-align: left;
    font-size: 34px;
  }
  @media ${Points.laptop_wide} {
    font-size: 54px;
    padding-right: 90px;
  }
`;
const Description = styled.div`
  font-size: 12px;
  line-height: 1.1;
  padding-right: 1px;

  @media ${Points.tablet_portrait} {
    text-align: center;
  }

  @media ${Points.laptop_wide} {
    text-align: left;
    font-size: 14px;
  }
`;
const Text = styled.div`
  font-size: 18px;
  line-height: 1.3;
  margin-bottom: 30px;

  p {
    margin-bottom: 15px;

    @media ${Points.laptop_wide} {
      margin-bottom: 20px;
    }
  }

  @media ${Points.laptop_wide} {
    margin-bottom: 40px;
  }
`;
